import { ZOOM_DELTA } from '../../constants';
import { canZoom } from '../../utils';
import { BaseCommand, baseCommand } from '../base';

export const zoomOutCommand: BaseCommand = {
  ...baseCommand,

  canUndo() {
    return false;
  },

  canExecute(graph) {
    return canZoom(graph, 'out');
  },

  execute(graph) {
    const ratio = 1 - ZOOM_DELTA;

    const zoom = graph.getZoom() * ratio;
    const minZoom = graph.get('minZoom');

    if (zoom < minZoom) return;

    graph.zoom(ratio);
  },

  shortcuts: [
    ['metaKey', '-'],
    ['ctrlKey', '-'],
  ],
};

export default zoomOutCommand;
